var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLhb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 80,
    r: 80,
    fill: "#F7F6F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 30H39.0476V80.5967H69.0476V89.4272H30V30Z",
    fill: "#6E6F71"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M84.0464 30H93.0941V53.8663H120.951V30H129.999V89.4272H120.951V62.4582H92.856V89.4272H84.0464V30Z",
    fill: "#6E6F71"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0952 108.282H30V130H43.0952V108.282Z",
    fill: "#D6DB29"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4761 108.282H43.0952V130H55.4761V108.282Z",
    fill: "#4CBEC6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M67.8559 108.282H55.4749V130H67.8559V108.282Z",
    fill: "#8F4199"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M80.2357 108.282H67.8547V130H80.2357V108.282Z",
    fill: "#F58368"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M92.6214 108.282H80.2404V130H92.6214V108.282Z",
    fill: "#1085C3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M105.001 108.282H92.6202V130H105.001V108.282Z",
    fill: "#F9C415"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M117.621 108.282H105.24V130H117.621V108.282Z",
    fill: "#9B9E92"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M130.001 108.282H117.62V130H130.001V108.282Z",
    fill: "#F69320"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white",
    transform: "translate(30 30)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLhb);
export default __webpack_public_path__ + "static/media/lhb.e10aa632.svg";
export { ForwardRef as ReactComponent };